import Vue from "vue";
export var ServiceFormEventBus = new Vue();